import { render, staticRenderFns } from "./CreateVariable.vue?vue&type=template&id=bdfe6d56"
import script from "./CreateVariable.vue?vue&type=script&lang=js"
export * from "./CreateVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports